import React from 'react';
import Category from './Category';

const categories = (props) => {
  return (
    <div className="AS-categories">
      {props.categories.map((category,index) =>
        <Category
          key={category.name}
          clicked={() => props.clicked(index)}
          label={category.name}
          isFocused={props.currentIndex === index}>
        </Category>
      )}
    </div>
  )
}

export default categories;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/list/Categories.js